// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Navbar Styles */

.navbar-custom {
  background: var(--bg-card);
  box-shadow: var(--shadow-md);
  position: sticky;
  top: 0;
  z-index: 1030;
  height: var(--app-topbar-h, 69px);
  border-bottom: 1px solid var(--border);
  backdrop-filter: blur(10px);
  margin-left: 240px;
  width: calc(100% - 240px);
  transition: margin-left 0.25s ease, width 0.25s ease;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  height: 100%;
  width: 100%;
  gap: 1rem;
}

@media (max-width: 992px) {
  .navbar-custom {
    margin-left: 0;
    width: 100%;
  }
}

.navbar-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.navbar-left {
  flex: 1 1;
}

.navbar-right {
  flex-shrink: 0;
}

/* Navbar Brand */
.navbar-brand-custom {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  cursor: pointer;
  text-decoration: none;
  padding: 0.65rem 0.9rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  white-space: nowrap;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
}

.navbar-brand-custom:hover {
  background-color: var(--slate-200);
  transform: translateY(-1px);
  border-color: var(--slate-300);
}

.navbar-icon {
  font-size: 1.6rem;
  filter: drop-shadow(0 3px 6px rgba(0,0,0,0.2));
}

.navbar-brand-texts {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
}

.navbar-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: 0.5px;
}

.navbar-subtitle {
  font-size: 0.75rem;
  color: var(--text-secondary);
  opacity: 0.9;
}

/* Company block */
.navbar-company {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.company-selector-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.company-chip-label {
  color: var(--text-secondary);
  font-size: 0.75rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
}

.company-selector {
  padding: 0.35rem 0.65rem;
  border: 1px solid var(--slate-300);
  background-color: var(--bg-input);
  color: var(--text-primary);
  border-radius: 6px;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  outline: none;
  min-width: 180px;
}

.company-selector:hover {
  background-color: var(--slate-200);
  border-color: var(--slate-400);
}

.company-selector:focus {
  background-color: var(--bg-input);
  border-color: var(--accent);
}

.company-selector option {
  /* Las \`<option>\` nativas no se componen sobre la barra: con un fondo
     translúcido el texto claro quedaba ilegible. */
  background-color: var(--bg-surface);
  color: var(--text-primary);
}

/* Actions Container */
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* Action Buttons */
.navbar-action-btn {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  color: var(--text-primary);
  cursor: pointer;
  padding: 0.35rem 0.65rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.navbar-action-btn:hover {
  background-color: var(--slate-200);
  border-color: var(--slate-300);
  color: var(--accent-l);
  transform: translateY(-1px);
}

.action-label {
  display: inline;
  font-size: 0.8rem;
  letter-spacing: 0.4px;
}

/* User Menu */
.navbar-user-menu {
  position: relative;
  display: flex;
  align-items: center;
}

.navbar-alerts {
  position: relative;
}

.navbar-alerts-btn {
  position: relative;
}

.navbar-alerts-btn.active {
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(245, 158, 11, 0.12);
  color: #fcd34d;
}

.navbar-alert-icon {
  width: 17px;
  height: 17px;
}

.navbar-feedback-btn {
  border-color: rgba(16, 185, 129, 0.35);
  background: rgba(16, 185, 129, 0.12);
  color: #6ee7b7;
}

.navbar-feedback-btn:hover {
  border-color: rgba(16, 185, 129, 0.55);
  background: rgba(16, 185, 129, 0.2);
  color: #a7f3d0;
}

.navbar-feedback-icon {
  width: 17px;
  height: 17px;
}

/* Acceso a los tutoriales guiados: mismo tamaño que el resto de acciones de la
   barra, con el violeta del tutorial para que se distinga. */
.navbar-tour-btn {
  border-color: rgba(139, 92, 246, 0.38);
  background: rgba(139, 92, 246, 0.14);
  color: #c4b5fd;
}

.navbar-tour-btn:hover {
  border-color: rgba(139, 92, 246, 0.6);
  background: rgba(139, 92, 246, 0.22);
  color: #ede9fe;
}

.navbar-tour-icon {
  font-size: 1rem;
  line-height: 1;
}

.navbar-alert-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f97316, #ef4444);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navbar-alerts-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: min(380px, calc(100vw - 1rem));
  /* Flota: superficie opaca (mismo motivo que en el panel de versión). */
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  z-index: 1040;
  animation: slideDown 0.2s ease;
}

.navbar-alerts-header {
  padding: 0.85rem 1rem;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.14), rgba(15, 23, 42, 0.1));
  border-bottom: 1px solid var(--border);
}

.navbar-alerts-title {
  font-size: 0.92rem;
  font-weight: 800;
  color: var(--text-primary);
}

.navbar-alerts-subtitle {
  font-size: 0.78rem;
  color: var(--text-secondary);
  margin-top: 0.2rem;
}

.navbar-alerts-list {
  max-height: 360px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.navbar-alert-item {
  width: 100%;
  border: none;
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
  background: transparent;
  padding: 0.85rem 1rem;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  transition: background 0.15s ease;
}

.navbar-alert-item:hover {
  background: rgba(var(--accent-rgb), 0.08);
}

.navbar-alert-item--critical {
  box-shadow: inset 3px 0 0 #ef4444;
}

.navbar-alert-item--warning {
  box-shadow: inset 3px 0 0 #f59e0b;
}

.navbar-alert-item--info {
  box-shadow: inset 3px 0 0 #38bdf8;
}

.navbar-alert-item-title {
  color: var(--text-primary);
  font-size: 0.88rem;
  font-weight: 700;
}

.navbar-alert-item-message {
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.4;
}

.navbar-alerts-empty {
  padding: 1rem;
  color: var(--text-muted);
  font-size: 0.84rem;
}

/* Avatar redondo del usuario: abre «Mi perfil». */
.navbar-avatar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  margin-left: 0.25rem;
  border: 1px solid rgba(var(--accent-rgb), 0.35);
  border-radius: 999px;
  background: linear-gradient(135deg, #6ee7ff, #1a9be6);
  color: #0b1630;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(26, 155, 230, 0.3);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.navbar-avatar-btn:hover,
.navbar-avatar-btn:focus-visible {
  transform: translateY(-1px) scale(1.04);
  box-shadow: 0 6px 16px rgba(26, 155, 230, 0.45);
  outline: none;
}

.navbar-avatar-btn:focus-visible {
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.35);
}

.navbar-avatar-initials {
  font-weight: 800;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  line-height: 1;
}

/* Cerrar sesión: botón redondo al lado del avatar. */
.navbar-logout-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid rgba(220, 38, 38, 0.28);
  border-radius: 999px;
  background: rgba(220, 38, 38, 0.1);
  color: #f87171;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.18s ease;
}

.navbar-logout-btn:hover,
.navbar-logout-btn:focus-visible {
  background: rgba(220, 38, 38, 0.2);
  border-color: rgba(220, 38, 38, 0.5);
  color: #fca5a5;
  transform: translateY(-1px);
  outline: none;
}

.navbar-logout-icon {
  width: 18px;
  height: 18px;
}

/* User Dropdown */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Sidebar Toggle */
.navbar-toggle-mobile {
  display: none;
  background: var(--bg-toolbar);
  border: 1px solid var(--slate-200);
  color: var(--text-primary);
  font-size: 1.35rem;
  cursor: pointer;
  padding: 0.45rem;
  border-radius: 10px;
  transition: all 0.2s ease;
  margin-right: 0.35rem;
}

.navbar-toggle-mobile:hover {
  background-color: var(--slate-200);
}

/* Responsive */
@media (max-width: 992px) {
  .navbar-content {
    padding: 0 1rem;
  }

  .navbar-title {
    font-size: 1.1rem;
  }

  .navbar-company {
    min-width: 210px;
  }
}

@media (max-width: 768px) {
  .navbar-custom {
    height: 64px;
  }

  .navbar-content {
    padding: 0 0.75rem;
  }

  .navbar-toggle-mobile {
    display: block;
  }

  .navbar-brand-custom {
    padding: 0.4rem 0.65rem;
    gap: 0.55rem;
  }

  .navbar-icon {
    font-size: 1.35rem;
  }

  .navbar-subtitle {
    display: none;
  }

  .navbar-action-btn {
    padding: 0.4rem 0.65rem;
    font-size: 0.85rem;
  }

  .navbar-alerts-dropdown {
    right: -3.5rem;
  }
}

@media (max-width: 480px) {
  .navbar-custom {
    height: 55px;
  }

  .navbar-content {
    padding: 0 0.5rem;
  }

  .navbar-title {
    display: none;
  }

  .navbar-icon {
    font-size: 1.25rem;
  }

  .language-btn {
    font-size: 1rem;
  }

  .navbar-avatar-btn,
  .navbar-logout-btn {
    width: 34px;
    height: 34px;
  }
}
/* ── App Launcher Toggle Button ── */
.navbar-launcher-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: var(--bg-toolbar);
  border: 1.5px solid var(--slate-200);
  border-radius: 10px;
  cursor: pointer;
  color: var(--text-secondary);
  flex-shrink: 0;
  transition: all 0.2s ease;
  padding: 0;
}

.navbar-launcher-btn:hover {
  background: var(--slate-200);
  border-color: var(--slate-300);
  color: var(--text-primary);
  transform: scale(1.05);
}

.navbar-launcher-btn.active {
  background: rgba(59, 130, 246, 0.35);
  border-color: rgba(59, 130, 246, 0.6);
  color: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.launcher-btn-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Mobile sidebar toggle */
.navbar-toggle-mobile {
  display: none;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: var(--bg-toolbar);
  border: 1.5px solid var(--slate-200);
  border-radius: 10px;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 1.2rem;
  transition: all 0.2s;
}

.navbar-toggle-mobile:hover {
  background: var(--slate-200);
  color: var(--text-primary);
}

@media (max-width: 992px) {
  .navbar-toggle-mobile {
    display: flex;
  }
}

/* ── Version badge (arriba a la izquierda, pulsable) ── */
.navbar-version {
  position: relative;
  display: inline-flex;
  /* Es lo PRIMERO de la izquierda del todo, aunque en el JSX vaya después del
     selector de empresa (así no se toca el orden del resto de controles). */
  order: -1;
}

.navbar-version-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  font-size: 0.7rem;
  font-family: 'Courier New', monospace;
  color: var(--text-secondary, #64748b);
  background: var(--bg-toolbar, #f1f5f9);
  border: 1px solid var(--slate-200, #e2e8f0);
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: all;
          user-select: all;
}

.navbar-version-badge:hover { border-color: var(--primary, #6366f1); }
.navbar-version-badge.active {
  border-color: var(--primary, #6366f1);
  color: var(--text-primary);
}

.navbar-version-badge .version-ref {
  color: var(--primary, #6366f1);
  font-weight: 600;
}

/* Aviso: la BD no está migrada o falta alguna capacidad desplegada */
.navbar-version-badge .version-warn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #dc2626;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 800;
}

/* ── Panel de versión ── */
.navbar-version-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: min(470px, calc(100vw - 1rem));
  max-height: min(72vh, 620px);
  overflow-y: auto;
  /* \`--bg-surface\`, NO \`--bg-card\`: este panel FLOTA sobre la página y la
     tarjeta puede ser de cristal. En Lumina Dark \`--bg-card\` es blanco al
     4,8 %, así que detrás se leía el contenido de la pantalla. */
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  z-index: 1040;
  animation: slideDown 0.2s ease;
}

.navbar-version-head {
  padding: 0.85rem 1rem;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.16), rgba(15, 23, 42, 0.08));
  border-bottom: 1px solid var(--border);
}

.navbar-version-title {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--text-primary);
}

.navbar-version-date {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-secondary, #64748b);
}

.navbar-version-sub {
  margin-top: 2px;
  font-size: 0.75rem;
  color: var(--text-secondary, #64748b);
}

.navbar-version-sub code,
.navbar-version-db code {
  font-family: 'Courier New', monospace;
  font-size: 0.72rem;
  background: rgba(99, 102, 241, 0.12);
  padding: 1px 5px;
  border-radius: 4px;
  color: var(--primary, #6366f1);
}

.navbar-version-db {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 0.5rem;
  font-size: 0.74rem;
  font-weight: 600;
}

.navbar-version-db.is-ok { color: #15803d; }
.navbar-version-db.is-bad { color: #b91c1c; }

.navbar-version-section {
  padding: 0.7rem 1rem;
  border-bottom: 1px solid var(--border);
}

.navbar-version-section:last-child { border-bottom: 0; }

.navbar-version-section-title {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary, #64748b);
  margin-bottom: 0.4rem;
}

.navbar-version-release-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.navbar-version-list {
  margin: 0;
  padding-left: 1.05rem;
}

.navbar-version-list li {
  font-size: 0.76rem;
  color: var(--text-secondary, #64748b);
  margin-bottom: 3px;
  line-height: 1.35;
}

.navbar-version-features {
  list-style: none;
  margin: 0;
  padding: 0;
}

.navbar-version-features li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.78rem;
  padding: 3px 0;
}

.navbar-version-features li.is-ok { color: var(--text-primary); }
.navbar-version-features li.is-bad { color: #b91c1c; font-weight: 600; }
.navbar-version-mark { font-weight: 800; }
.navbar-version-features li.is-ok .navbar-version-mark { color: #15803d; }

.navbar-version-hint {
  margin-top: 0.45rem;
  font-size: 0.7rem;
  color: var(--text-secondary, #64748b);
  line-height: 1.35;
}

.navbar-version-past {
  padding: 0.6rem 1rem 0.8rem;
}

.navbar-version-past summary {
  cursor: pointer;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-secondary, #64748b);
}

.navbar-version-past .navbar-version-release { margin-top: 0.5rem; }

/* ═══════════════════════════════════════════════════════════════════════════
   MÓVIL — la barra no cabe con etiquetas
   ───────────────────────────────────────────────────────────────────────────
   Los controles medían 1035 px y se salían de la pantalla: el avatar, los
   avisos y hasta el selector de empresa quedaban fuera. Aquí la barra se queda
   en iconos, el selector de empresa se hace pequeño y las acciones secundarias
   (tutoriales, ticket, favorito y el badge de versión) desaparecen: se llega a
   ellas desde el menú lateral o desde la ficha. El bloque va AL FINAL del
   archivo a propósito, para ganar a las reglas base que se definen más arriba.
   ═══════════════════════════════════════════════════════════════════════════ */
@media (max-width: 768px) {
  .navbar-content {
    gap: 0.35rem;
    padding: 0 0.5rem;
  }

  .navbar-section {
    gap: 0.35rem;
    min-width: 0;
  }

  .navbar-left {
    flex: 1 1 auto;
    min-width: 0;
  }

  .navbar-right {
    flex: 0 0 auto;
    gap: 0.3rem;
  }

  .navbar-company {
    min-width: 0;
  }

  .company-selector-wrap {
    gap: 0;
  }

  /* La etiqueta «EMPRESA» es lo primero que sobra. */
  .company-chip-label {
    display: none;
  }

  .company-selector {
    min-width: 0;
    width: 92px;
    max-width: 26vw;
    padding: 0.3rem 0.4rem;
    font-size: 0.78rem;
  }

  /* Botones de acción: solo el icono. */
  .navbar-action-btn {
    padding: 0.45rem;
  }

  .navbar-action-btn .action-label {
    display: none;
  }

  /* Badge de versión: se consulta en escritorio; aquí roba el sitio del título. */
  .navbar-version {
    display: none;
  }

  /* Acciones secundarias: accesibles desde el menú lateral. */
  .navbar-tour-btn,
  .navbar-feedback-btn,
  .navbar-fav {
    display: none;
  }

  .navbar-avatar-btn,
  .navbar-logout-btn {
    width: 34px;
    height: 34px;
  }

  /* El desplegable de avisos no puede colgar de un botón pegado al borde. */
  .navbar-alerts-dropdown {
    position: fixed;
    top: calc(var(--app-topbar-h, 64px) + 0.35rem);
    left: 0.5rem;
    right: 0.5rem;
    width: auto;
  }
}

@media (max-width: 480px) {
  .navbar-custom {
    height: 55px;
  }

  .navbar-content {
    padding: 0 0.5rem;
  }

  .navbar-title {
    display: none;
  }

  .company-selector {
    width: 82px;
    font-size: 0.74rem;
  }

  .navbar-launcher-btn {
    padding: 0.4rem;
  }

  .navbar-icon {
    font-size: 1.25rem;
  }

  .language-btn {
    font-size: 1rem;
  }

  .navbar-avatar-btn,
  .navbar-logout-btn {
    width: 34px;
    height: 34px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE;mDACiD;EACjD,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;6DAC6D;AAC7D;EACE,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,qCAAqC;EACrC,uEAAuE;EACvE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,oFAAoF;EACpF,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,+CAA+C;EAC/C,oBAAoB;EACpB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;;EAEE,uCAAuC;EACvC,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;AACA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,oBAAoB;EACpB;4EAC0E;EAC1E,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA,8BAA8B,qCAAqC,EAAE;AACrE;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB;;iEAE+D;EAC/D,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,qFAAqF;EACrF,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,4BAA4B,cAAc,EAAE;;AAE5C;EACE,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,qCAAqC,gBAAgB,EAAE;;AAEvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC,0BAA0B,EAAE;AAChE,qCAAqC,cAAc,EAAE,gBAAgB,EAAE;AACvE,uBAAuB,gBAAgB,EAAE;AACzC,yDAAyD,cAAc,EAAE;;AAEzE;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,+CAA+C,kBAAkB,EAAE;;AAEnE;;;;;;;;;gFASgF;AAChF;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,MAAM;EACR;;EAEA,mDAAmD;EACnD;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,gFAAgF;EAChF;IACE,aAAa;EACf;;EAEA,4DAA4D;EAC5D;;;IAGE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA,0EAA0E;EAC1E;IACE,eAAe;IACf,8CAA8C;IAC9C,YAAY;IACZ,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Modern Navbar Styles */\r\n\r\n.navbar-custom {\r\n  background: var(--bg-card);\r\n  box-shadow: var(--shadow-md);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1030;\r\n  height: var(--app-topbar-h, 69px);\r\n  border-bottom: 1px solid var(--border);\r\n  backdrop-filter: blur(10px);\r\n  margin-left: 240px;\r\n  width: calc(100% - 240px);\r\n  transition: margin-left 0.25s ease, width 0.25s ease;\r\n}\r\n\r\n.navbar-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 1.25rem;\r\n  height: 100%;\r\n  width: 100%;\r\n  gap: 1rem;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .navbar-custom {\r\n    margin-left: 0;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.navbar-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.navbar-left {\r\n  flex: 1;\r\n}\r\n\r\n.navbar-right {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Navbar Brand */\r\n.navbar-brand-custom {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  padding: 0.65rem 0.9rem;\r\n  border-radius: 12px;\r\n  transition: all 0.3s ease;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.12);\r\n}\r\n\r\n.navbar-brand-custom:hover {\r\n  background-color: var(--slate-200);\r\n  transform: translateY(-1px);\r\n  border-color: var(--slate-300);\r\n}\r\n\r\n.navbar-icon {\r\n  font-size: 1.6rem;\r\n  filter: drop-shadow(0 3px 6px rgba(0,0,0,0.2));\r\n}\r\n\r\n.navbar-brand-texts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.navbar-title {\r\n  font-size: 1.3rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.navbar-subtitle {\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary);\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Company block */\r\n.navbar-company {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.company-selector-wrap {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.company-chip-label {\r\n  color: var(--text-secondary);\r\n  font-size: 0.75rem;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.company-selector {\r\n  padding: 0.35rem 0.65rem;\r\n  border: 1px solid var(--slate-300);\r\n  background-color: var(--bg-input);\r\n  color: var(--text-primary);\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  transition: all 0.2s ease;\r\n  outline: none;\r\n  min-width: 180px;\r\n}\r\n\r\n.company-selector:hover {\r\n  background-color: var(--slate-200);\r\n  border-color: var(--slate-400);\r\n}\r\n\r\n.company-selector:focus {\r\n  background-color: var(--bg-input);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.company-selector option {\r\n  /* Las `<option>` nativas no se componen sobre la barra: con un fondo\r\n     translúcido el texto claro quedaba ilegible. */\r\n  background-color: var(--bg-surface);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Actions Container */\r\n.navbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Action Buttons */\r\n.navbar-action-btn {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  padding: 0.35rem 0.65rem;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\r\n}\r\n\r\n.navbar-action-btn:hover {\r\n  background-color: var(--slate-200);\r\n  border-color: var(--slate-300);\r\n  color: var(--accent-l);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.action-label {\r\n  display: inline;\r\n  font-size: 0.8rem;\r\n  letter-spacing: 0.4px;\r\n}\r\n\r\n/* User Menu */\r\n.navbar-user-menu {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-alerts {\r\n  position: relative;\r\n}\r\n\r\n.navbar-alerts-btn {\r\n  position: relative;\r\n}\r\n\r\n.navbar-alerts-btn.active {\r\n  border-color: rgba(245, 158, 11, 0.35);\r\n  background: rgba(245, 158, 11, 0.12);\r\n  color: #fcd34d;\r\n}\r\n\r\n.navbar-alert-icon {\r\n  width: 17px;\r\n  height: 17px;\r\n}\r\n\r\n.navbar-feedback-btn {\r\n  border-color: rgba(16, 185, 129, 0.35);\r\n  background: rgba(16, 185, 129, 0.12);\r\n  color: #6ee7b7;\r\n}\r\n\r\n.navbar-feedback-btn:hover {\r\n  border-color: rgba(16, 185, 129, 0.55);\r\n  background: rgba(16, 185, 129, 0.2);\r\n  color: #a7f3d0;\r\n}\r\n\r\n.navbar-feedback-icon {\r\n  width: 17px;\r\n  height: 17px;\r\n}\r\n\r\n/* Acceso a los tutoriales guiados: mismo tamaño que el resto de acciones de la\r\n   barra, con el violeta del tutorial para que se distinga. */\r\n.navbar-tour-btn {\r\n  border-color: rgba(139, 92, 246, 0.38);\r\n  background: rgba(139, 92, 246, 0.14);\r\n  color: #c4b5fd;\r\n}\r\n\r\n.navbar-tour-btn:hover {\r\n  border-color: rgba(139, 92, 246, 0.6);\r\n  background: rgba(139, 92, 246, 0.22);\r\n  color: #ede9fe;\r\n}\r\n\r\n.navbar-tour-icon {\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.navbar-alert-badge {\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: linear-gradient(135deg, #f97316, #ef4444);\r\n  color: #fff;\r\n  font-size: 0.7rem;\r\n  font-weight: 800;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.navbar-alerts-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 0.5rem);\r\n  right: 0;\r\n  width: min(380px, calc(100vw - 1rem));\r\n  /* Flota: superficie opaca (mismo motivo que en el panel de versión). */\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  box-shadow: var(--shadow-lg);\r\n  overflow: hidden;\r\n  z-index: 1040;\r\n  animation: slideDown 0.2s ease;\r\n}\r\n\r\n.navbar-alerts-header {\r\n  padding: 0.85rem 1rem;\r\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.14), rgba(15, 23, 42, 0.1));\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.navbar-alerts-title {\r\n  font-size: 0.92rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.navbar-alerts-subtitle {\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.navbar-alerts-list {\r\n  max-height: 360px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.navbar-alert-item {\r\n  width: 100%;\r\n  border: none;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.14);\r\n  background: transparent;\r\n  padding: 0.85rem 1rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.navbar-alert-item:hover {\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n}\r\n\r\n.navbar-alert-item--critical {\r\n  box-shadow: inset 3px 0 0 #ef4444;\r\n}\r\n\r\n.navbar-alert-item--warning {\r\n  box-shadow: inset 3px 0 0 #f59e0b;\r\n}\r\n\r\n.navbar-alert-item--info {\r\n  box-shadow: inset 3px 0 0 #38bdf8;\r\n}\r\n\r\n.navbar-alert-item-title {\r\n  color: var(--text-primary);\r\n  font-size: 0.88rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.navbar-alert-item-message {\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.navbar-alerts-empty {\r\n  padding: 1rem;\r\n  color: var(--text-muted);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n/* Avatar redondo del usuario: abre «Mi perfil». */\r\n.navbar-avatar-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n  margin-left: 0.25rem;\r\n  border: 1px solid rgba(var(--accent-rgb), 0.35);\r\n  border-radius: 999px;\r\n  background: linear-gradient(135deg, #6ee7ff, #1a9be6);\r\n  color: #0b1630;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  box-shadow: 0 4px 12px rgba(26, 155, 230, 0.3);\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n\r\n.navbar-avatar-btn:hover,\r\n.navbar-avatar-btn:focus-visible {\r\n  transform: translateY(-1px) scale(1.04);\r\n  box-shadow: 0 6px 16px rgba(26, 155, 230, 0.45);\r\n  outline: none;\r\n}\r\n\r\n.navbar-avatar-btn:focus-visible {\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.35);\r\n}\r\n\r\n.navbar-avatar-initials {\r\n  font-weight: 800;\r\n  font-size: 0.8rem;\r\n  letter-spacing: 0.5px;\r\n  line-height: 1;\r\n}\r\n\r\n/* Cerrar sesión: botón redondo al lado del avatar. */\r\n.navbar-logout-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n  border: 1px solid rgba(220, 38, 38, 0.28);\r\n  border-radius: 999px;\r\n  background: rgba(220, 38, 38, 0.1);\r\n  color: #f87171;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: all 0.18s ease;\r\n}\r\n\r\n.navbar-logout-btn:hover,\r\n.navbar-logout-btn:focus-visible {\r\n  background: rgba(220, 38, 38, 0.2);\r\n  border-color: rgba(220, 38, 38, 0.5);\r\n  color: #fca5a5;\r\n  transform: translateY(-1px);\r\n  outline: none;\r\n}\r\n\r\n.navbar-logout-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n/* User Dropdown */\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Mobile Sidebar Toggle */\r\n.navbar-toggle-mobile {\r\n  display: none;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--slate-200);\r\n  color: var(--text-primary);\r\n  font-size: 1.35rem;\r\n  cursor: pointer;\r\n  padding: 0.45rem;\r\n  border-radius: 10px;\r\n  transition: all 0.2s ease;\r\n  margin-right: 0.35rem;\r\n}\r\n\r\n.navbar-toggle-mobile:hover {\r\n  background-color: var(--slate-200);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 992px) {\r\n  .navbar-content {\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .navbar-title {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .navbar-company {\r\n    min-width: 210px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .navbar-custom {\r\n    height: 64px;\r\n  }\r\n\r\n  .navbar-content {\r\n    padding: 0 0.75rem;\r\n  }\r\n\r\n  .navbar-toggle-mobile {\r\n    display: block;\r\n  }\r\n\r\n  .navbar-brand-custom {\r\n    padding: 0.4rem 0.65rem;\r\n    gap: 0.55rem;\r\n  }\r\n\r\n  .navbar-icon {\r\n    font-size: 1.35rem;\r\n  }\r\n\r\n  .navbar-subtitle {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-action-btn {\r\n    padding: 0.4rem 0.65rem;\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .navbar-alerts-dropdown {\r\n    right: -3.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .navbar-custom {\r\n    height: 55px;\r\n  }\r\n\r\n  .navbar-content {\r\n    padding: 0 0.5rem;\r\n  }\r\n\r\n  .navbar-title {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-icon {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .language-btn {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .navbar-avatar-btn,\r\n  .navbar-logout-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n}\r\n/* ── App Launcher Toggle Button ── */\r\n.navbar-launcher-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  background: var(--bg-toolbar);\r\n  border: 1.5px solid var(--slate-200);\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  flex-shrink: 0;\r\n  transition: all 0.2s ease;\r\n  padding: 0;\r\n}\r\n\r\n.navbar-launcher-btn:hover {\r\n  background: var(--slate-200);\r\n  border-color: var(--slate-300);\r\n  color: var(--text-primary);\r\n  transform: scale(1.05);\r\n}\r\n\r\n.navbar-launcher-btn.active {\r\n  background: rgba(59, 130, 246, 0.35);\r\n  border-color: rgba(59, 130, 246, 0.6);\r\n  color: #fff;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\r\n}\r\n\r\n.launcher-btn-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Mobile sidebar toggle */\r\n.navbar-toggle-mobile {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  background: var(--bg-toolbar);\r\n  border: 1.5px solid var(--slate-200);\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  font-size: 1.2rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.navbar-toggle-mobile:hover {\r\n  background: var(--slate-200);\r\n  color: var(--text-primary);\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .navbar-toggle-mobile {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n/* ── Version badge (arriba a la izquierda, pulsable) ── */\r\n.navbar-version {\r\n  position: relative;\r\n  display: inline-flex;\r\n  /* Es lo PRIMERO de la izquierda del todo, aunque en el JSX vaya después del\r\n     selector de empresa (así no se toca el orden del resto de controles). */\r\n  order: -1;\r\n}\r\n\r\n.navbar-version-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 2px 10px;\r\n  font-size: 0.7rem;\r\n  font-family: 'Courier New', monospace;\r\n  color: var(--text-secondary, #64748b);\r\n  background: var(--bg-toolbar, #f1f5f9);\r\n  border: 1px solid var(--slate-200, #e2e8f0);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  user-select: all;\r\n}\r\n\r\n.navbar-version-badge:hover { border-color: var(--primary, #6366f1); }\r\n.navbar-version-badge.active {\r\n  border-color: var(--primary, #6366f1);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.navbar-version-badge .version-ref {\r\n  color: var(--primary, #6366f1);\r\n  font-weight: 600;\r\n}\r\n\r\n/* Aviso: la BD no está migrada o falta alguna capacidad desplegada */\r\n.navbar-version-badge .version-warn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background: #dc2626;\r\n  color: #fff;\r\n  font-size: 0.62rem;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ── Panel de versión ── */\r\n.navbar-version-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 0.5rem);\r\n  left: 0;\r\n  width: min(470px, calc(100vw - 1rem));\r\n  max-height: min(72vh, 620px);\r\n  overflow-y: auto;\r\n  /* `--bg-surface`, NO `--bg-card`: este panel FLOTA sobre la página y la\r\n     tarjeta puede ser de cristal. En Lumina Dark `--bg-card` es blanco al\r\n     4,8 %, así que detrás se leía el contenido de la pantalla. */\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  box-shadow: var(--shadow-lg);\r\n  z-index: 1040;\r\n  animation: slideDown 0.2s ease;\r\n}\r\n\r\n.navbar-version-head {\r\n  padding: 0.85rem 1rem;\r\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.16), rgba(15, 23, 42, 0.08));\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.navbar-version-title {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.5rem;\r\n  font-size: 0.95rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.navbar-version-date {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary, #64748b);\r\n}\r\n\r\n.navbar-version-sub {\r\n  margin-top: 2px;\r\n  font-size: 0.75rem;\r\n  color: var(--text-secondary, #64748b);\r\n}\r\n\r\n.navbar-version-sub code,\r\n.navbar-version-db code {\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 0.72rem;\r\n  background: rgba(99, 102, 241, 0.12);\r\n  padding: 1px 5px;\r\n  border-radius: 4px;\r\n  color: var(--primary, #6366f1);\r\n}\r\n\r\n.navbar-version-db {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  margin-top: 0.5rem;\r\n  font-size: 0.74rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.navbar-version-db.is-ok { color: #15803d; }\r\n.navbar-version-db.is-bad { color: #b91c1c; }\r\n\r\n.navbar-version-section {\r\n  padding: 0.7rem 1rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.navbar-version-section:last-child { border-bottom: 0; }\r\n\r\n.navbar-version-section-title {\r\n  font-size: 0.68rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-secondary, #64748b);\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.navbar-version-release-title {\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.navbar-version-list {\r\n  margin: 0;\r\n  padding-left: 1.05rem;\r\n}\r\n\r\n.navbar-version-list li {\r\n  font-size: 0.76rem;\r\n  color: var(--text-secondary, #64748b);\r\n  margin-bottom: 3px;\r\n  line-height: 1.35;\r\n}\r\n\r\n.navbar-version-features {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.navbar-version-features li {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  font-size: 0.78rem;\r\n  padding: 3px 0;\r\n}\r\n\r\n.navbar-version-features li.is-ok { color: var(--text-primary); }\r\n.navbar-version-features li.is-bad { color: #b91c1c; font-weight: 600; }\r\n.navbar-version-mark { font-weight: 800; }\r\n.navbar-version-features li.is-ok .navbar-version-mark { color: #15803d; }\r\n\r\n.navbar-version-hint {\r\n  margin-top: 0.45rem;\r\n  font-size: 0.7rem;\r\n  color: var(--text-secondary, #64748b);\r\n  line-height: 1.35;\r\n}\r\n\r\n.navbar-version-past {\r\n  padding: 0.6rem 1rem 0.8rem;\r\n}\r\n\r\n.navbar-version-past summary {\r\n  cursor: pointer;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: var(--text-secondary, #64748b);\r\n}\r\n\r\n.navbar-version-past .navbar-version-release { margin-top: 0.5rem; }\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   MÓVIL — la barra no cabe con etiquetas\r\n   ───────────────────────────────────────────────────────────────────────────\r\n   Los controles medían 1035 px y se salían de la pantalla: el avatar, los\r\n   avisos y hasta el selector de empresa quedaban fuera. Aquí la barra se queda\r\n   en iconos, el selector de empresa se hace pequeño y las acciones secundarias\r\n   (tutoriales, ticket, favorito y el badge de versión) desaparecen: se llega a\r\n   ellas desde el menú lateral o desde la ficha. El bloque va AL FINAL del\r\n   archivo a propósito, para ganar a las reglas base que se definen más arriba.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n@media (max-width: 768px) {\r\n  .navbar-content {\r\n    gap: 0.35rem;\r\n    padding: 0 0.5rem;\r\n  }\r\n\r\n  .navbar-section {\r\n    gap: 0.35rem;\r\n    min-width: 0;\r\n  }\r\n\r\n  .navbar-left {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n  }\r\n\r\n  .navbar-right {\r\n    flex: 0 0 auto;\r\n    gap: 0.3rem;\r\n  }\r\n\r\n  .navbar-company {\r\n    min-width: 0;\r\n  }\r\n\r\n  .company-selector-wrap {\r\n    gap: 0;\r\n  }\r\n\r\n  /* La etiqueta «EMPRESA» es lo primero que sobra. */\r\n  .company-chip-label {\r\n    display: none;\r\n  }\r\n\r\n  .company-selector {\r\n    min-width: 0;\r\n    width: 92px;\r\n    max-width: 26vw;\r\n    padding: 0.3rem 0.4rem;\r\n    font-size: 0.78rem;\r\n  }\r\n\r\n  /* Botones de acción: solo el icono. */\r\n  .navbar-action-btn {\r\n    padding: 0.45rem;\r\n  }\r\n\r\n  .navbar-action-btn .action-label {\r\n    display: none;\r\n  }\r\n\r\n  /* Badge de versión: se consulta en escritorio; aquí roba el sitio del título. */\r\n  .navbar-version {\r\n    display: none;\r\n  }\r\n\r\n  /* Acciones secundarias: accesibles desde el menú lateral. */\r\n  .navbar-tour-btn,\r\n  .navbar-feedback-btn,\r\n  .navbar-fav {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-avatar-btn,\r\n  .navbar-logout-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n\r\n  /* El desplegable de avisos no puede colgar de un botón pegado al borde. */\r\n  .navbar-alerts-dropdown {\r\n    position: fixed;\r\n    top: calc(var(--app-topbar-h, 64px) + 0.35rem);\r\n    left: 0.5rem;\r\n    right: 0.5rem;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .navbar-custom {\r\n    height: 55px;\r\n  }\r\n\r\n  .navbar-content {\r\n    padding: 0 0.5rem;\r\n  }\r\n\r\n  .navbar-title {\r\n    display: none;\r\n  }\r\n\r\n  .company-selector {\r\n    width: 82px;\r\n    font-size: 0.74rem;\r\n  }\r\n\r\n  .navbar-launcher-btn {\r\n    padding: 0.4rem;\r\n  }\r\n\r\n  .navbar-icon {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .language-btn {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .navbar-avatar-btn,\r\n  .navbar-logout-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
